import { Dispatch } from "react"
import { SetDropdownItemsData, SetReferentialsData, ReferentialAction, ReferentialSyncActions, SetSingleItemData } from "./types"

const createSyncActions = (dispatch: Dispatch<ReferentialAction>): ReferentialSyncActions => ({
  setSingleItem: (data: SetSingleItemData) => {
    dispatch({ type: 'SET_SINGLE_ITEM', payload: data })
  },
  setDropdownItems: (data: SetDropdownItemsData) => {
    dispatch({ type: 'SET_DROPDOWN_ITEMS', payload: data })
  },
  setReferentials: (data: SetReferentialsData) => {
    dispatch({ type: 'SET_REFERENTIALS', payload: data })
  },
  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading })
  },
  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  },
  reset: () => {
    dispatch({ type: 'RESET' })
  }
})

export default createSyncActions
